export const formatNumber = (input) => {

	if (typeof input !== "number") return input;

	return input.toLocaleString();

};
